module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-600italic-811ca08800ce75bf36b23bddbba7c5b0.ttf";